<template>
  <b-card no-body>
    <b-tabs v-model="tabIndex" card>
      <b-tab title="Gerenciar empresas" @click="setBreadcrumbTabsName('Gerenciar empresas', 'Gerencie, edite ou exclua empresas e agentes')">
        <section v-if='tabIndex === 0'>
          <ManageCompanies></ManageCompanies>
        </section>
      </b-tab>
      <b-tab title="Gerenciar cargos" @click="setBreadcrumbTabsName('Gerenciar cargos', 'Gerencie, exclua cargos')">
        <section v-if='tabIndex === 1'>
          <ManageRoles></ManageRoles>
        </section>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ManageCompanies from '../components/ManageCompanies/ManageCompanies.vue'
import ManageRoles from '../components/ManageRoles/ManageRoles.vue'

export default {
  name: 'ManageCompaniesRoles',
  components: { ManageRoles, ManageCompanies },
  data() {
    return {
      tabIndex: 0
    }
  },
  created() {
    const breadcrumb = {
      tab: '',
      page: 'Gerenciar empresas',
      subPage: {
        name: 'Gerencie, edite ou exclua empresas e agentes',
        active: false
      },
      tabs: []
    }
    this.setBreadcrumb(breadcrumb)
  },

  async mounted() {
    try {

    } catch (e) {
    }
  },

  computed: {
    user() {
      return this.$store.getters['user/current']
    },
  },

  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    setBreadcrumbTabsName(page, subPageName){
      const breadcrumb = {
        page,
        subPage: {
          name: subPageName,
          active: false
        },
        tabs: []
      }
      this.setBreadcrumb(breadcrumb)
    }
  }
}
</script>


<style lang='scss' scoped>
</style>
